module.exports = __webpack_public_path__ + "img/paper-plane.677c3785.svg";